const normalizeErrors = (errors) => {
	if (!errors) return [];

	if (typeof errors === "string") return [errors];

	if (Array.isArray(errors)) {
		return errors
			.flatMap((error) => {
				if (!error) return [];
				if (typeof error === "string") return [error];
				if (Array.isArray(error)) return error.filter(Boolean);
				if (typeof error === "object") {
					if (typeof error.reason === "string") return [error.reason];
					return Object.values(error).flatMap((value) =>
						Array.isArray(value) ? value.filter(Boolean) : []
					);
				}
				return [String(error)];
			})
			.filter(Boolean);
	}

	if (typeof errors === "object") {
		if (Array.isArray(errors.failures)) return normalizeErrors(errors.failures);
		if (Array.isArray(errors.errors)) return normalizeErrors(errors.errors);
		if (Array.isArray(errors.successes) && errors.successes.length === 0) {
			return Object.values(errors)
				.flatMap((value) => normalizeErrors(value))
				.filter(Boolean);
		}

		return Object.values(errors)
			.flatMap((value) => normalizeErrors(value))
			.filter(Boolean);
	}

	return [String(errors)];
};

const ServerErrors = ({ errorMessage, errors }) => {
	const normalizedErrors = normalizeErrors(errors);

	return (
		<div>
			<h5 className="text-red-900 text-sm">
				{errorMessage || "Something went wrong"}
			</h5>

			{normalizedErrors.length > 0 && (
				<ul>
					{normalizedErrors.map((error, index) => {
						return (
							<li key={index}>
								{index + 1}. {error}
							</li>
						);
					})}
				</ul>
			)}
		</div>
	);
};

export default ServerErrors;
